import { useMemo } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Login from "@/pages/Login";
import Lobby from "@/pages/Lobby";
import Room from "@/pages/Room";
import Editions from "@/pages/Editions";
import Certificate from "@/pages/Certificate";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function Protected() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const fromState = useMemo(() => ({ from: location }), [location]);
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0C1530] flex items-center justify-center" data-testid="auth-loading">
        <div className="w-10 h-10 border-2 border-[#00C8FF] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={fromState} replace />;
  return (
    <div className="min-h-screen bg-[#0C1530]">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 pt-24 pb-12">
        <Outlet />
      </main>
    </div>
  );
}

function AdminOnly() {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/lobby" replace />;
  return <Outlet />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/primeiro-acesso" element={<Login />} />
            <Route element={<Protected />}>
              <Route path="/lobby" element={<Lobby />} />
              <Route path="/sala/:id" element={<Room />} />
              <Route path="/edicoes" element={<Editions />} />
              <Route path="/certificado" element={<Certificate />} />
              <Route path="/perfil" element={<Profile />} />
              <Route element={<AdminOnly />}>
                <Route path="/admin" element={<Admin />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/lobby" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
